export const categories = [
  {
    id: 'jiaoyou',
    name: '交友互动',
    slug: 'jiaoyou',
    description: '找到志同道合的朋友，拓展社交圈，开启真诚交流',
    icon: 'ri-heart-line',
    articleCount: 128,
  },
  {
    id: 'shenghuo',
    name: '生活资讯',
    slug: 'shenghuo',
    description: '健康、旅行、美食、时尚等全方位生活指南',
    icon: 'ri-compass-3-line',
    articleCount: 96,
  },
  {
    id: 'quanyi',
    name: '权益支持',
    slug: 'quanyi',
    description: '法律咨询、权益科普、心理健康支持资源',
    icon: 'ri-shield-line',
    articleCount: 74,
  },
  {
    id: 'gushi',
    name: '真实故事',
    slug: 'gushi',
    description: '聆听社群成员的真实经历与成长故事',
    icon: 'ri-book-open-line',
    articleCount: 156,
  },
  {
    id: 'huodong',
    name: '活动资讯',
    slug: 'huodong',
    description: '线上线下活动信息、骄傲月、社群聚会',
    icon: 'ri-calendar-event-line',
    articleCount: 63,
  },
  {
    id: 'jiankang',
    name: '健康专栏',
    slug: 'jiankang',
    description: '身心健康知识、防艾科普、医疗资源指南',
    icon: 'ri-heart-pulse-line',
    articleCount: 89,
  },
];